document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-current]');
    const viewport = gallery.querySelector('.product-gallery__viewport');
    let activeIndex = 0;
    let touchStartX = null;
    let touchStartY = null;

    const showSlide = (requestedIndex, focusThumb = false) => {
      if (!slides.length) return;
      activeIndex = (requestedIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
        if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
        slide.querySelectorAll('iframe').forEach((frame) => {
          const currentSource = frame.getAttribute('src');
          if (currentSource && currentSource !== 'about:blank') frame.dataset.gallerySource = currentSource;
          if (active && frame.dataset.gallerySource && currentSource !== frame.dataset.gallerySource) {
            frame.setAttribute('src', frame.dataset.gallerySource);
          }
          if (!active && currentSource && currentSource !== 'about:blank') frame.setAttribute('src', 'about:blank');
        });
      });
      thumbs.forEach((thumb, index) => thumb.setAttribute('aria-current', String(index === activeIndex)));
      if (counter) counter.textContent = String(activeIndex + 1);
      if (focusThumb && thumbs[activeIndex]) thumbs[activeIndex].focus();
    };

    previous?.addEventListener('click', () => showSlide(activeIndex - 1));
    next?.addEventListener('click', () => showSlide(activeIndex + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
    gallery.addEventListener('variant:media', (event) => {
      const mediaId = String(event.detail?.mediaId || '');
      if (!mediaId) return;
      const mediaIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === mediaId);
      if (mediaIndex >= 0) showSlide(mediaIndex);
    });
    gallery.addEventListener('keydown', (event) => {
      if (event.target.closest('video, iframe, model-viewer')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(activeIndex - 1, true);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(activeIndex + 1, true);
      }
    });
    viewport?.addEventListener('touchstart', (event) => {
      if (event.target.closest('video, iframe, model-viewer, button, a, input, select, textarea')) return;
      touchStartX = event.changedTouches[0]?.clientX ?? null;
      touchStartY = event.changedTouches[0]?.clientY ?? null;
    }, { passive: true });
    viewport?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
      const touchEndY = event.changedTouches[0]?.clientY ?? touchStartY;
      const distanceX = touchEndX - touchStartX;
      const distanceY = touchEndY - touchStartY;
      if (Math.abs(distanceX) > 45 && Math.abs(distanceX) > Math.abs(distanceY) * 1.15) {
        showSlide(activeIndex + (distanceX < 0 ? 1 : -1));
      }
      touchStartX = null;
      touchStartY = null;
    }, { passive: true });
    showSlide(0);
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('.variant-select');
    const price = section.querySelector('[data-product-price]');
    const stock = section.querySelector('[data-product-stock]');
    const stockLabel = section.querySelector('[data-product-stock-label]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const gate = section.querySelector('[data-installation-gate]');
    const choiceGroups = [...section.querySelectorAll('[data-option-position]')];
    if (!select || !addButton) return;
    section.classList.add('variant-controls--ready');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    const syncChoiceButtons = () => {
      const selectedVariant = select.options[select.selectedIndex];
      choiceGroups.forEach((group) => {
        const position = Number(group.dataset.optionPosition || 0);
        const selectedValue = selectedVariant?.getAttribute(`data-option-${position}`) || '';
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.optionValue === selectedValue));
        });
      });
    };

    choiceGroups.forEach((group) => {
      const position = Number(group.dataset.optionPosition || 0);
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          const currentVariant = select.options[select.selectedIndex];
          const requestedValues = [1, 2, 3].map((index) => currentVariant?.getAttribute(`data-option-${index}`) || '');
          requestedValues[position - 1] = button.dataset.optionValue || '';
          const matchingVariant = [...select.options].find((option) => requestedValues.every((value, index) => {
            if (!value) return true;
            return option.getAttribute(`data-option-${index + 1}`) === value;
          }));
          if (!matchingVariant) return;
          select.value = matchingVariant.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    const refresh = () => {
      const option = select.options[select.selectedIndex];
      const installation = option.dataset.installation === 'true';
      const available = option.dataset.available === 'true';
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (stock) {
        stock.dataset.available = String(available);
        if (stockLabel) stockLabel.textContent = installation ? 'Compatibility approval required' : (available ? 'Available to order' : 'Currently unavailable');
      }
      if (gate) gate.hidden = !installation;
      addButton.hidden = installation;
      addButton.disabled = installation || !available;
      addButton.textContent = available ? 'Add to cart — Supply only' : 'Sold out';
      if (option.dataset.featuredMediaId) {
        section.querySelector('[data-product-gallery]')?.dispatchEvent(new CustomEvent('variant:media', {
          detail: { mediaId: option.dataset.featuredMediaId },
        }));
      }
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', nextUrl);
      syncChoiceButtons();
    };

    select.addEventListener('change', refresh);
    refresh();
  });

  document.querySelectorAll('.product-accordions details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      details.parentElement.querySelectorAll('details').forEach((other) => {
        if (other !== details) other.open = false;
      });
    });
  });

  document.querySelectorAll('.mobile-menu').forEach((menu) => {
    const summary = menu.querySelector('summary');
    const syncState = () => {
      summary?.setAttribute('aria-expanded', String(menu.open));
      summary?.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
    };
    menu.addEventListener('toggle', syncState);
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { menu.open = false; }));
    document.addEventListener('pointerdown', (event) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !menu.open) return;
      menu.open = false;
      summary?.focus();
    });
    syncState();
  });

  const chatTrigger = document.querySelector('[data-chat-open]');
  let connectedChat = null;
  let chatOpenedFromHeader = false;
  let chatWasOpen = false;

  const connectHeaderChat = () => {
    if (!chatTrigger || connectedChat) return Boolean(connectedChat);
    const chat = document.querySelector('shopify-chat');
    if (!chat || typeof chat.show !== 'function') return false;

    connectedChat = chat;
    document.documentElement.classList.add('inbox-custom-launcher-ready');

    const syncChatState = () => {
      const isOpen = chat.hasAttribute('open') || chat.open === true;
      chatTrigger.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) chatWasOpen = true;
      if (!isOpen && chatWasOpen && chatOpenedFromHeader) {
        chatOpenedFromHeader = false;
        chatWasOpen = false;
        chatTrigger.focus({ preventScroll: true });
      }
    };

    new MutationObserver(syncChatState).observe(chat, { attributes: true, attributeFilter: ['open'] });
    chatTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      chatOpenedFromHeader = true;
      try {
        chat.show();
        publishEvent('live_chat_opened', { destination: 'shopify_inbox' });
        window.setTimeout(syncChatState, 0);
      } catch (_) {
        chatOpenedFromHeader = false;
        document.documentElement.classList.remove('inbox-custom-launcher-ready');
        window.location.assign(chatTrigger.href);
      }
    });
    syncChatState();
    return true;
  };

  if (chatTrigger && !connectHeaderChat()) {
    const chatObserver = new MutationObserver(() => {
      if (connectHeaderChat()) chatObserver.disconnect();
    });
    chatObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => chatObserver.disconnect(), 15000);
  }

  const resetSocialVideo = (card, returnFocus = false) => {
    const button = card.querySelector('[data-social-video-load]');
    const media = card.querySelector('[data-social-video-media]');
    const closeButton = card.querySelector('[data-social-video-close]');
    if (!button || !media || !closeButton) return;

    if (media instanceof HTMLVideoElement) {
      media.pause();
      media.muted = true;
      const source = media.querySelector('[data-social-video-source]');
      source?.removeAttribute('src');
      media.load();
    } else {
      media.removeAttribute('src');
    }
    media.hidden = true;
    closeButton.hidden = true;
    button.hidden = false;
    button.setAttribute('aria-expanded', 'false');
    if (returnFocus) button.focus();
  };

  const initializeSocialVideoSection = (section) => {
    if (section.dataset.socialVideoReady === 'true') return;
    section.dataset.socialVideoReady = 'true';
    const socialVideoCards = [...section.querySelectorAll('[data-social-video-card]')];

    socialVideoCards.forEach((card) => {
      const button = card.querySelector('[data-social-video-load]');
      const media = card.querySelector('[data-social-video-media]');
      const closeButton = card.querySelector('[data-social-video-close]');
      if (!button || !media || !closeButton) return;

      button.addEventListener('click', () => {
        socialVideoCards.forEach((otherCard) => {
          if (otherCard !== card) resetSocialVideo(otherCard);
        });

        if (media instanceof HTMLVideoElement) {
          const source = media.querySelector('[data-social-video-source]');
          if (!source?.dataset.src) return;
          source.src = source.dataset.src;
          media.load();
        } else {
          if (!media.dataset.src) return;
          media.src = media.dataset.src;
        }

        media.hidden = false;
        button.hidden = true;
        button.setAttribute('aria-expanded', 'true');
        closeButton.hidden = false;
        if (media instanceof HTMLVideoElement) media.play().catch(() => {});
        window.setTimeout(() => {
          if (media instanceof HTMLVideoElement) media.focus();
          else closeButton.focus();
        }, 0);
      });
      if (media instanceof HTMLVideoElement) {
        media.addEventListener('error', () => resetSocialVideo(card));
      }
      closeButton.addEventListener('click', () => resetSocialVideo(card, true));
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !media.hidden) resetSocialVideo(card, true);
      });
    });

    section.querySelectorAll('[data-social-media-tabs]').forEach((tabs) => {
      const tabButtons = [...tabs.querySelectorAll('[data-social-media-tab]')];
      const panels = [...tabs.querySelectorAll('[data-social-media-panel]')];
      if (tabButtons.length < 2 || panels.length < 2) return;

      const activateTab = (nextTab, moveFocus = false) => {
        const target = nextTab.dataset.socialMediaTab;
        tabButtons.forEach((tab) => {
          const selected = tab === nextTab;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.socialMediaPanel === target;
          panel.removeAttribute('data-social-media-initial-hidden');
          panel.hidden = !selected;
          if (!selected && panel.dataset.socialMediaPanel === 'videos') {
            panel.querySelectorAll('[data-social-video-card]').forEach((card) => resetSocialVideo(card));
          }
        });
        if (moveFocus) nextTab.focus();
      };

      tabButtons.forEach((tab) => tab.addEventListener('click', () => activateTab(tab)));
      tabs.querySelector('[role="tablist"]')?.addEventListener('keydown', (event) => {
        const currentIndex = tabButtons.indexOf(document.activeElement);
        if (currentIndex < 0) return;
        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length;
        else if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabButtons.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabButtons.length - 1;
        else return;
        event.preventDefault();
        activateTab(tabButtons[nextIndex], true);
      });
      activateTab(tabButtons.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabButtons[0]);
    });
  };

  const initializeSocialVideoSections = (root = document) => {
    const sections = [];
    if (root instanceof Element && root.matches('[data-social-video-section], [data-work-library]')) sections.push(root);
    root.querySelectorAll?.('[data-social-video-section], [data-work-library]').forEach((section) => sections.push(section));
    sections.forEach(initializeSocialVideoSection);
  };

  initializeSocialVideoSections();
  document.addEventListener('shopify:section:load', (event) => initializeSocialVideoSections(event.target));

  const loadRelatedProducts = (container) => {
    if (!container.dataset.url) return;
    if (container.dataset.loaded === 'true') return;
    container.dataset.loaded = 'true';
    fetch(container.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const rendered = parsed.querySelector('[data-related-products]');
        if (rendered?.innerHTML.trim()) {
          container.innerHTML = rendered.innerHTML;
          container.closest('.related-products-section')?.removeAttribute('hidden');
        }
        else container.closest('.related-products-section')?.setAttribute('hidden', '');
      })
      .catch(() => container.closest('.related-products-section')?.setAttribute('hidden', ''));
  };

  document.querySelectorAll('[data-related-products]').forEach((container) => {
    if (!('IntersectionObserver' in window)) {
      loadRelatedProducts(container);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      loadRelatedProducts(container);
    }, { rootMargin: '500px 0px' });
    observer.observe(container);
  });

  document.querySelectorAll('[data-lock-comparison]').forEach((comparison) => {
    const filters = [...comparison.querySelectorAll('[data-comparison-filter]')];
    const cards = [...comparison.querySelectorAll('[data-comparison-card]')];
    const empty = comparison.querySelector('[data-comparison-empty]');
    const status = comparison.querySelector('[data-comparison-status]');
    filters.forEach((filter) => filter.addEventListener('click', () => {
      const selected = filter.dataset.comparisonFilter;
      filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
      let visible = 0;
      cards.forEach((card) => {
        const matches = selected === 'all' || card.dataset.matchTags.split(' ').includes(selected);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
      if (status) status.textContent = `Showing ${visible} smart lock${visible === 1 ? '' : 's'}.`;
    }));
  });

  document.querySelectorAll('[data-work-library]').forEach((library) => {
    const filters = [...library.querySelectorAll('[data-work-filter]')];
    const cards = [...library.querySelectorAll('[data-work-card]')];
    const more = library.querySelector('[data-work-more]');
    const status = library.querySelector('[data-work-status]');
    let selected = 'all';
    let expanded = false;
    const initialLimit = window.matchMedia('(max-width: 760px)').matches ? 8 : 12;

    const refresh = () => {
      const matching = cards.filter((card) => selected === 'all' || card.dataset.workCategory === selected);
      matching.forEach((card, index) => { card.hidden = !expanded && index >= initialLimit; });
      cards.filter((card) => !matching.includes(card)).forEach((card) => { card.hidden = true; });
      if (more) {
        more.hidden = matching.length <= initialLimit;
        more.textContent = expanded ? 'Show fewer projects' : `Show ${matching.length - initialLimit} more`;
        more.setAttribute('aria-expanded', String(expanded));
      }
      if (status) status.textContent = `Showing ${expanded ? matching.length : Math.min(matching.length, initialLimit)} of ${matching.length} matching projects.`;
    };

    filters.forEach((filter) => filter.addEventListener('click', () => {
      selected = filter.dataset.workFilter;
      expanded = false;
      filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
      refresh();
    }));
    more?.addEventListener('click', () => { expanded = !expanded; refresh(); });
    refresh();
  });

  const initializeCompatibilityEmbedValidation = () => {
    if (window.location.pathname !== '/pages/door-compatibility') return;

    const preparedInputs = new WeakSet();
    const preparedForms = new WeakSet();
    const observedRoots = new WeakSet();
    const permittedImageExtensions = ['heic', 'heif', 'jpg', 'jpeg', 'webp'];
    const maximumImageBytes = 20 * 1024 * 1024;

    const setRequired = (input, required = true) => {
      if (!input) return;
      input.required = required;
      if (required) input.setAttribute('aria-required', 'true');
      else input.removeAttribute('aria-required');
    };

    const validateImage = (input) => {
      const file = input.files?.[0];
      let message = '';
      if (file) {
        const extension = file.name.split('.').pop()?.toLowerCase() || '';
        if (!permittedImageExtensions.includes(extension)) {
          message = 'Please upload a HEIC, HEIF, JPEG or WebP image.';
        } else if (file.size > maximumImageBytes) {
          message = 'Please choose an image smaller than 20 MB.';
        }
      }
      input.setCustomValidity(message);
      return !message;
    };

    const configureForm = () => {
      const host = document.querySelector('shopify-forms-embed');
      const root = host?.shadowRoot;
      const form = root?.querySelector('form');
      if (!root || !form) return false;

      const getField = (id) => root.getElementById(id);
      [
        'first_name',
        'email',
        'phone_number',
        'custom#suburb_postcode',
        'custom#actual_door_thickness_mm',
      ].forEach((id) => setRequired(getField(id)));

      const email = getField('email');
      if (email) {
        email.setAttribute('inputmode', 'email');
        email.setAttribute('pattern', '[^\\s@]+@[^\\s@]+\\.[^\\s@]+');
        email.setAttribute('title', 'Enter a valid email address.');
      }

      const securityDoorRadios = [...root.querySelectorAll('input[name="custom#security_or_screen_door"]')];
      setRequired(securityDoorRadios[0]);
      const securityDoorYes = getField('custom#security_or_screen_door-Yes');

      const fileInputs = [...root.querySelectorAll('input[type="file"]')];
      fileInputs.forEach((input, index) => {
        input.accept = '.heic,.heif,.jpg,.jpeg,.webp,image/heic,image/heif,image/jpeg,image/webp';
        setRequired(input, index < 5);
        if (preparedInputs.has(input)) return;
        preparedInputs.add(input);
        input.addEventListener('change', () => {
          if (!validateImage(input)) input.reportValidity();
        });
      });

      const conditionalClearancePhoto = fileInputs[5];
      const updateClearanceRequirement = () => {
        if (!conditionalClearancePhoto) return;
        setRequired(conditionalClearancePhoto, Boolean(securityDoorYes?.checked));
      };
      securityDoorRadios.forEach((radio) => {
        if (preparedInputs.has(radio)) return;
        preparedInputs.add(radio);
        radio.addEventListener('change', updateClearanceRequirement);
      });
      updateClearanceRequirement();

      const photoAuthorisation = root.querySelector('input[name="custom#photo_authorisation"]');
      setRequired(photoAuthorisation);

      const enforceValidity = (event) => {
        configureForm();
        root.querySelectorAll('input[type="file"]').forEach(validateImage);
        if (form.checkValidity()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        form.reportValidity();
        root.querySelector(':invalid')?.focus();
      };

      if (!preparedForms.has(form)) {
        preparedForms.add(form);
        form.addEventListener('submit', enforceValidity, true);
      }

      const submitButton = [...root.querySelectorAll('button')]
        .find((button) => /request compatibility/i.test(button.textContent || ''));
      if (submitButton && !preparedInputs.has(submitButton)) {
        preparedInputs.add(submitButton);
        submitButton.addEventListener('click', enforceValidity, true);
      }

      if (!observedRoots.has(root)) {
        observedRoots.add(root);
        const formObserver = new MutationObserver(() => window.queueMicrotask(configureForm));
        formObserver.observe(root, { childList: true, subtree: true });
      }
      return true;
    };

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (configureForm() || attempts >= 60) window.clearInterval(timer);
    }, 250);
  };

  initializeCompatibilityEmbedValidation();

  const publishEvent = (name, data = {}) => {
    try {
      const payload = {
        page_path: window.location.pathname,
        ...data,
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: `automations_smart_${name}`, ...payload });
      if (!window.Shopify?.analytics?.publish) return;
      const result = window.Shopify.analytics.publish(`automations_smart:${name}`, payload);
      result?.catch?.(() => {});
    } catch (_) {}
  };

  document.addEventListener('click', (event) => {
    const tracked = event.target.closest('[data-track-event]');
    if (tracked) {
      publishEvent(tracked.dataset.trackEvent, { label: tracked.dataset.trackLabel || tracked.textContent.trim().slice(0, 80) });
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.startsWith('tel:')) publishEvent('phone_clicked', { destination: 'phone' });
    else if (href.includes('/pages/door-compatibility')) publishEvent('compatibility_check_started', { destination: '/pages/door-compatibility' });
    else if (href.includes('google.com/maps')) publishEvent('review_source_clicked', { destination: 'google_maps' });
  });

  document.addEventListener('submit', (event) => {
    if (event.target.closest('[data-compatibility-form]')) publishEvent('compatibility_submitted');
    else if (event.target.closest('[data-contact-form]')) publishEvent('contact_submitted');
  });

  document.querySelectorAll('[data-compatibility-form]').forEach((formArea) => {
    let started = false;
    formArea.addEventListener('focusin', () => {
      if (started) return;
      started = true;
      publishEvent('compatibility_started');
    });
    formArea.addEventListener('change', (event) => {
      if (event.target.matches('input[type="file"]') && event.target.files?.length) {
        const slots = [...formArea.querySelectorAll('input[type="file"]')];
        publishEvent('door_photo_selected', { slot: Math.max(1, slots.indexOf(event.target) + 1) });
      }
    });
  });

  if (document.querySelector('[data-compatibility-success]')) publishEvent('compatibility_success');
  if (document.querySelector('[data-contact-success]')) publishEvent('contact_success');
});
